import Swiper from 'swiper';
import {Autoplay, Navigation} from 'swiper/modules';
import {getOptionsFromJsonString} from "../../default/global/js/utilities/options";

export function initBrandScrollbar(query = document.querySelectorAll('.js-brandScrollbar')) {
    Swiper.use([Autoplay, Navigation]);

    for (const el of query) {
        if (el.dataset.brandScrollbarInit) {
            continue;
        }
        el.dataset.brandScrollbarInit = "true";

        const options = getOptionsFromJsonString(el.dataset.options, {
            autoplay_interval: 3000,
            eff_interval: 1000
        });

        new Swiper(el, {
            slidesPerView: 1.25,
            spaceBetween: 20,
            speed: options.eff_interval,
            autoplay: {
                delay: options.autoplay_interval,
            },
            loop: true,
            navigation: {
                nextEl: el.querySelector('.swiper-button-next'),
                prevEl: el.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.25
                }
            }
        });
    }
}
